import React, { useState } from "react";
import {
  FormControl,
  Button,
  Box,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import roundClearAll from "@iconify/icons-ic/round-clear-all";
import { Icon } from "@iconify/react";
import MUIAutocomplete from "../../components/MUIAutocomplete";

export default function TransactionsFilter({
  handleClearFilter,
  filterData,
  searchSubmitFilter,
  handleChangeOthers,
  deposit,
  userList,
  handleGetDetailUser,
  is_clear = true,
}) {
  const [SelectedTypeFilter, setSelectedTypeFilter] = useState(
    is_clear
      ? [
          { label: "Credit Card", value: "credit_card" },
          { label: "Crypto Transfer", value: "crypto" },
          { label: "Domestic Wire", value: "domestic_wire" },
          { label: "International Wire", value: "international_wire" },
          { label: "Wise Transfer", value: "wise_transfer" },
        ]
      : [
          { label: "Domestic Wire", value: "domestic_wire" },
          { label: "International Wire", value: "international_wire" },
          { label: "Wise Transfer", value: "wise_transfer" },
        ]
  );
  return (
    <div className="container-fluid new-memories transaction-filter">
      <div className="col-12 mt-4">
        <MUIAutocomplete
          setCustomSearch={(value) => handleGetDetailUser(value)}
          multiple={false}
          inputLabel="Users"
          selectedOption={filterData.user || null}
          setSelectedOption={(e) => {
            handleChangeOthers("user", e);
          }}
          optionsList={userList}
          name="name"
        />
      </div>
      {deposit && (
        <div className="col-12 mt-3">
          <FormControl fullWidth className="">
            <InputLabel id="demo-simple-select-label">Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterData.status_value}
              name="status_value"
              label="Status"
              onChange={(e) =>
                handleChangeOthers("status_value", e.target.value)
              }
            >
              {/* <MenuItem value={"succeeded"}>Approved</MenuItem> */}
              <MenuItem value={"failed"}>Rejected</MenuItem>
              <MenuItem value={"pending"}>Pending</MenuItem>
              {/* <MenuItem value={"requires_action"}>Needs Changes</MenuItem> */}
            </Select>
          </FormControl>
        </div>
      )}
      <FormControl fullWidth className="mt-3">
        <InputLabel id="demo-simple-select-label">Deposit Method</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={filterData.payment_made_by}
          name="payment_made_by"
          label="Deposit Method"
          onChange={(e) =>
            handleChangeOthers("payment_made_by", e.target.value)
          }
        >
          {SelectedTypeFilter.map((value, index) => (
            <MenuItem key={index} value={value.value}>
              {value.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box sx={{ py: 2 }}>
        <Button
          fullWidth
          size="large"
          type="submit"
          color="inherit"
          variant="outlined"
          onClick={searchSubmitFilter}
          startIcon={
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 5 }}
            >
              <path
                d="M13.1165 0.25H0.883548C0.321452 0.25 0.0378205 0.932013 0.436097 1.33029L5.3125 6.20743V11.6406C5.3125 11.8471 5.41325 12.0406 5.58242 12.1591L7.69179 13.6351C8.10794 13.9264 8.6875 13.6312 8.6875 13.1167V6.20743L13.564 1.33029C13.9615 0.932804 13.6798 0.25 13.1165 0.25Z"
                fill="#fff"
              />
            </svg>
          }
        >
          Filter
        </Button>
      </Box>
      <Button
        className="mb-3"
        fullWidth
        size="large"
        type="submit"
        color="inherit"
        variant="outlined"
        onClick={handleClearFilter}
        startIcon={<Icon icon={roundClearAll} />}
      >
        Clear All
      </Button>
    </div>
  );
}
